
import { timeRangeOptions, RETURN_REASON_OPTIONS } from "@/utils/options";
import { PurchaseOrderEnum } from "modules/purchase/purchase-order/enum";

const dateTypeOptions = [
    {id: 'createDate', text: '创建时间'},
    {id: 'expectDeliveryDate', text: '预计交货时间'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '状态',
    prop: 'statusList',
    components: [{
        name: 'gj-select',
        prop: 'statusList',
        propsData: {
            options: PurchaseOrderEnum.statusOption,
            multiple: true,
            collapseTags: true,
            placeholder: '状态'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '供应商',
    prop: 'supplierCode',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-supplier-select',
        prop: 'supplierCode',
        propsData: {
            placeholder: '供应商',
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '采购仓',
    prop: 'warehouseId',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseId',
        propsData: {
            placeholder: '采购仓',
            fba: false,
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '创建人',
    prop: 'creator',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-creator-select',
        prop: 'creator',
        propsData: {
            placeholder: '创建人',

        }
    }],
    defaultValue: ''
},{
    label: '采购员',
    prop: 'purchaser',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-creator-select',
        prop: 'purchaser',
        propsData: {
            placeholder: '采购员',

        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    },{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'createDate'
}]
